import React from 'react';
import { Row, Col, FormGroup } from 'reactstrap';
import { InputCheckbox } from '../../views/DayOff/form/style';

const WeekdaySelector = ({ value, onChange }) => {
  const handleCheckboxChange = (day) => {
    const newDays = { ...value, [day]: !value[day] };
    onChange(newDays);
  };

  return (
    <Row>
      <Col>
        <label className="form-control-label">Repetir:</label>
        <FormGroup style={{ marginLeft: '4rem', marginTop: '-2rem' }}>
          <InputCheckbox>
            <input
              type="checkbox"
              checked={value.sun}
              className="checkbox-round-sun"
              onChange={() => handleCheckboxChange('sun')}
            />
            <h5 id="input-sun">D</h5>

            <input
              type="checkbox"
              checked={value.mon}
              className="checkbox-round-mon"
              onChange={() => handleCheckboxChange('mon')}
            />
            <h5 id="input-mon">S</h5>

            <input
              type="checkbox"
              checked={value.tue}
              className="checkbox-round-tue"
              onChange={() => handleCheckboxChange('tue')}
            />
            <h5 id="input-tue">T</h5>

            <input
              type="checkbox"
              checked={value.wed}
              className="checkbox-round-wed"
              onChange={() => handleCheckboxChange('wed')}
            />
            <h5 id="input-wed">Q</h5>

            <input
              type="checkbox"
              checked={value.thu}
              className="checkbox-round-thu"
              onChange={() => handleCheckboxChange('thu')}
            />
            <h5 id="input-thu">Q</h5>

            <input
              type="checkbox"
              checked={value.fri}
              className="checkbox-round-fri"
              onChange={() => handleCheckboxChange('fri')}
            />
            <h5 id="input-fri">S</h5>

            <input
              type="checkbox"
              checked={value.sat}
              className="checkbox-round-sat"
              onChange={() => handleCheckboxChange('sat')}
            />
            <h5 id="input-sat">S</h5>
          </InputCheckbox>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default WeekdaySelector;
